<template>
  <div class=" mt-2">
    <b-breadcrumb class="breadcrumb-pipes">
      <b-breadcrumb-item href="/settings/admin-panel/">
          Admin Panel
        </b-breadcrumb-item>
        <b-breadcrumb-item href="/settings/user-role">
          Roles and Permissions
        </b-breadcrumb-item>
        <b-breadcrumb-item href="/settings/personal-settings">
          Personal Settings
        </b-breadcrumb-item>
      </b-breadcrumb>
    <b-card class="mb-0" :title="$t('settings.holiday.titles.manage_holidays')">
      <b-overlay :show="loading" rounded="sm" no-fade>
        <div class="m-2">
          <b-row align-h="between">
            <b-col cols="12" md="3">
              <b-form-input
                v-model="filter"
                class="d-inline-block mr-1"
                cle
                :placeholder="$t('general_text.search_table')"
              />
            </b-col>
            <b-col v-if="$Can('add_holiday')" cols="12" md="3">
              <div class="d-flex align-items-center justify-content-end">
                <b-button variant="success" @click="createHolidayModal">
                  <span class="text-nowrap"> {{ $t('settings.holiday.button.create_new_holiday') }} </span>
                </b-button>
              </div>
            </b-col>
          </b-row>
        </div>

        <b-table
          striped
          hover
          ref="refHolidayTable"
          class="position-relative p-2"
          :items="allHolidays"
          :filter="filter"
          filter-debounce="250"
          @filtered="onFiltered"
          :filter-included-fields="filterOn"
          selectable
          select-mode="single"
          responsive
          :small="true"
          head-variant="dark"
          :fields="tableColumns"
          show-empty
          :empty-text="$t('general_messages.no_matching_recors_found')"
          :current-page="currentPage"
          :per-page="perPage"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortByDesc"
          
        >
          <!-- Column: date -->
          <template #cell(Date)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{
                  data.item.Date ? dateFormat(data.item.Date) : "N/A"
                }}</strong>
              </span></b
            >
          </template>

          <!-- Column: Currency -->
          <template #cell(Currency)="data">
            <b
              ><span class="font-weight-bold text-primary">
                <strong>{{
                  data.item.Currency ? data.item.Currency : "N/A"
                }}</strong>
              </span></b
            >
          </template>

          <!-- Column: Description -->
          <template #cell(Description)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{
                  data.item.Description ? data.item.Description : "N/A"
                }}</strong>
              </span></b
            >
          </template>

          <!-- Column: UserSaved -->
          <template #cell(UserSaved)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{
                  data.item.UserSaved ? data.item.UserSaved : "N/A"
                }}</strong>
              </span></b
            >
          </template>

          <!-- Column: SaveDateTime -->
          <template #cell(SaveDateTime)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{
                  data.item.created_at
                    ? dateFormatWithTime(data.item.created_at)
                    : "N/A"
                }}</strong>
              </span></b
            >
          </template>

          <!-- Column: Actions -->
          <template #cell(actions)="data">
            <b-dropdown
              variant="link"
              no-caret
              :right="$store.state.appConfig.isRTL"
            >
              <template #button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="align-middle text-body"
                />
              </template>
              <b-dropdown-item @click="deleteHoliday(data.item)">
                <feather-icon icon="DeleteIcon" />
                <span class="align-middle ml-50">{{ $t('settings.holiday.button.delete_holiday') }}</span>
              </b-dropdown-item>
            </b-dropdown>
          </template>
        </b-table>

        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
            <span class="text-muted"
                >{{$t('general_text.showing')}} {{ dataMeta.from }} {{$t('general_text.to')}} {{ dataMeta.to }} {{$t('general_text.of')}}
                {{ dataMeta.of }} {{$t('general_text.entries')}}</span
              >
            </b-col>

            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-overlay>
      {{ /*holiday create modal*/ }}
      <b-modal
        id="modal-prevent-closing"
        v-model="holidayCreateModal"
        :title="$t('settings.holiday.titles.create_new_holiday')"
        @hidden="resetHolidayCreateModal"
        size="lg"
        :ok-title="$t('settings.holiday.button.create')"
        :cancel-title="$t('settings.holiday.button.cancel')"
        @ok="createHoliday"
      >
        <b-overlay :show="createHolidayloading" rounded="sm" no-fade>
          <b-container>
            <validation-observer ref="createValidation">
              <b-form>
                <b-row class="mt-2">
                  <b-col cols="6" xl="6" lg="6" md="6" sm="12">
                    <!-- description-->
                    <b-form-group>
                      <validation-provider
                        #default="{ errors }"
                        :name="$t('settings.holiday.form.description')"
                        rules="required"
                      >
                        <b-form-input
                          id="description"
                          v-model="newHoliday.description"
                          name="description"
                          :state="errors.length > 0 ? false : null"
                          :placeholder="$t('settings.holiday.form.description')"
                          autofocus
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col cols="6" xl="6" lg="6" md="6" sm="12">
                    <b-form-group>
                      <validation-provider
                        #default="{ errors }"
                        :name="$t('settings.holiday.form.date')"
                        rules="required"
                      >
                        <b-input-group>
                          <flat-pickr
                            :placeholder="$t('settings.holiday.form.date')"
                            v-model="newHoliday.date"
                            onClose="testClose"
                            class="form-control"
                          />
                          <b-input-group-append>
                            <b-button @click="clearDate()" variant="success"
                              >{{ $t('settings.holiday.button.clear') }}</b-button
                            >
                          </b-input-group-append>
                        </b-input-group>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                  <b-col cols="6"  xl="6" md="6" lg="6" sm="12" class="mt-2">
                    <b-form-input
                      v-model="filterModal"
                      class="d-inline-block mr-1"
                      cle
                      :placeholder="$t('general_text.search_table')"
                    />
                  </b-col>

                  <b-col
                    cols="12"
                    xl="12"
                    md="12"
                    sm="12"
                    class="bodyRow mt-1"
                    style="padding: 0.5rem 0;"
                  >
                    <b-table
                      hover
                      responsive
                      small
                      :filter="filterModal"
                      filter-debounce="250"
                      :filter-included-fields="filterModalOn"
                      fixed
                      :items="allCurrencies"
                      class="position-relative"
                      :fields="detailCurrenciesColumns"
                      style="padding-left: 1rem;"
                    >
                      <template #cell(Currency)="data">
                        <strong>{{ data.item.Currency }}</strong>
                      </template>

                      <template #cell()="data">
                        <b-form-checkbox
                          switch
                          size="sm"
                          v-model="data.item.value"
                        >
                        </b-form-checkbox>
                      </template>
                    </b-table>
                  </b-col>
                </b-row>
              </b-form>
            </validation-observer>
          </b-container>
          <template #overlay v-if="createHolidayloading">
            <div
              class="text-center d-flex justify-content-center align-items-start"
            >
              <b-icon icon="stopwatch" font-scale="3" animation="cylon">
              </b-icon>
              <p id="cancel-label">
                <feather-icon icon="DownloadIcon" /> {{ $t('settings.holiday.messages.holiday_create_message') }} 
              </p>
            </div>
          </template>
        </b-overlay>
        {{/****END*** holiday create modal*/}}
      </b-modal>
    </b-card>
  </div>
</template>

<script>
import {
  BOverlay,
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BFormRating,
  VBModal,
  BTabs,
  BTab,
  BCardText,
  BIcon,
} from "bootstrap-vue";
import store from "@/store";
import { onUnmounted } from "@vue/composition-api";
import settingsStoreModule from "../../settingsStoreModule";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required, alphaNum, email, min, max } from "@validations";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import axios from "axios";
import axiosIns from "@/libs/axios";
import router from "@/router";
import moment from "moment";
import "animate.css";
import _ from "lodash";
import { mapState, mapGetters } from "vuex";
import { BBreadcrumb, BBreadcrumbItem } from 'bootstrap-vue'

export default {
  components: {
    BOverlay,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BTabs,
    BTab,
    BCardText,
    BDropdown,
    BDropdownItem,
    BPagination,
    BFormRating,
    BIcon,
    vSelect,
    ValidationProvider,
    ValidationObserver,
    ToastificationContent,
    flatPickr,
    BBreadcrumb, BBreadcrumbItem
  },

  directives: {
    Ripple,
    "b-modal": VBModal,
  },

  setup() {
    const SETTINGS_APP_STORE_MODULE_NAME = "settings";
    // Register module
    if (!store.hasModule(SETTINGS_APP_STORE_MODULE_NAME))
      store.registerModule(SETTINGS_APP_STORE_MODULE_NAME, settingsStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(SETTINGS_APP_STORE_MODULE_NAME))
        store.unregisterModule(SETTINGS_APP_STORE_MODULE_NAME);
    });
  },

  data() {
    return {
      allHolidays: [],
      holidayCreateModal: false,
      allCurrencies: [],
      filterModal: null,
      filterModalOn: ["Currency"],
      updatePermloading: false,
      createHolidayloading: false,
      newHoliday: {
        description: null,
        date: null,
        currencies: [],
      },
      sortByDesc: true,
      sortBy: 'ID',
      filterOn: ["Currency", "Description", "UserSaved"],
      tableColumns: [
        {
          key: "Date",
          label: this.$t('settings.holiday.table.date'),
          sortable: false,
        },
        {
          key: "Currency",
          label: this.$t('settings.holiday.table.currency'),
          sortable: true,
        },
        {
          key: "Description",
          label: this.$t('settings.holiday.table.description'),
          sortable: false,
        },
        {
          key: "UserSaved",
          label: this.$t('settings.holiday.table.user'),
          sortable: false,
        },
        {
          key: "SaveDateTime",
          label: this.$t('settings.holiday.table.save_date_time'),
          sortable: false,
        },
        { key: "actions", label: this.$t('settings.holiday.table.actions'), sortable:false },
      ],
      detailCurrenciesColumns: [
        {
          key: "Currency",
          label: this.$t('settings.holiday.table.currency'),
          sortable: false,
        },
        {
          key: "actions",
          label: "",
          sortable: false,
          class: "text-center",
        },
      ],
      perPage: 10,
      currentPage: 1,
      totalRows: 0,
      perPageOptions: [10, 25, 50, 100],
      filter: null,

      loading: false,
      rangeDate: null,
      filterDateStart: null,
      filterDateEnd: null,
    };
  },
  computed: {
    user: {
      get() {
        return this.$store.getters["authUser"];
      },
      set(newValue) {
        return this.$store.dispatch("setUser", newValue);
      },
    },
    ...mapGetters(["authUser"]),
    dataMeta() {
      return {
        from:
          this.totalRows != 0 ? this.perPage * (this.currentPage - 1) + 1 : 0,
        to:
          this.perPage * (this.currentPage - 1) + Number(this.perPage) <
          this.totalRows
            ? this.perPage * (this.currentPage - 1) + Number(this.perPage)
            : this.totalRows,
        of: this.totalRows,
      };
    },
  },
  mounted() {
    this.getHolidays();
  },
  methods: {
    getHolidays() {
      this.loading = true;
      store
        .dispatch("settings/fetchHolidays")
        .then((res) => {
          this.allHolidays = res.data;
          this.totalRows = res.data.length;
          this.loading = false;
        })
        .catch((error) => {
          this.databaseErrorMessage();
          console.log(error);
        });
    },
    createHolidayModal() {
      store
        .dispatch("settings/fetchHolidayCurrencies")
        .then((res) => {
          if (res.data.length > 0) {
            res.data.forEach((currency) => {
              currency.value = false;
            });
            this.allCurrencies = res.data;
            this.holidayCreateModal = true;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    createHoliday(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.$refs.createValidation.validate().then((success) => {
        if (success) {
          this.createHolidayloading = true;

          if (this.allCurrencies.length > 0) {
            this.allCurrencies.forEach((c) => {
              if (c.value) {
                this.newHoliday.currencies.push(c.Currency);
              }
            });
          }

          if (this.newHoliday.currencies.length > 0) {
            store
              .dispatch("settings/createNewHoliday", {
                user: this.user,
                holiday: this.newHoliday,
                savetime: moment().format("MM-DD-YYYY HH:mm:ss"),
              })
              .then((res) => {
                if (res.data.info.length == this.newHoliday.currencies.length) {
                  this.createHolidayloading = false;
                  this.resetHolidayCreateModal();
                  this.getHolidays();
                  this.createHolidayToastMessage();
                } else {
                  this.createHolidayloading = false;
                  this.wrongToastMessage(this.$t('settings.holiday.messages.holiday_added_error'));
                }
              })
              .catch((error) => {
                console.log(error);
              });
          } else {
            this.onlySelectOneCurrencyMessage();
          }
        }
      });
    },
    resetHolidayCreateModal() {
      this.holidayCreateModal = false;
      this.allCurrencies = []
      this.newHoliday = {
        description: null,
        date: null,
        currencies: [],
      };
    },
    deleteHoliday(holiday) {
      const self = this;
      this.$swal({
        title: this.$t('settings.holiday.messages.sure_delete_holiday') + ` ${holiday.Currency}`,
        // text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: this.$t('settings.holiday.button.yes_delete_it'),
        cancelButtonText: this.$t('settings.holiday.button.cancel'),
        customClass: {
          confirmButton: "btn btn-success mr-1",
          cancelButton: "btn btn-danger",
          denyButton: "btn btn-primary",
        },
        showClass: {
          popup: "animate__animated animate__fadeInDown",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOutUp",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          self.loading = true;
          store
            .dispatch("settings/deleteHoliday", {
              holiday: holiday,
            })
            .then((res) => {
              if (res.data.info == true) {
                self.getHolidays();
                self.loading = false;
                self.$swal.fire({
                  icon: "success",
                  title: self.$t('settings.holiday.titles.deleted'),
                  text: self.$t('settings.holiday.messages.holiday_deleted'),
                  showClass: {
                    popup: "animate__animated animate__fadeInDown",
                  },
                });
              } else {
                this.holidayNotFoundMessage();
                self.loading = false;
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      });
    },
    databaseErrorMessage(val) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Error",
          text: this.$t('settings.holiday.messages.database_connection_error'),
          icon: "AlertTriangleIcon",
          variant: "danger",
        },
      });
    },
    onlySelectOneCurrencyMessage(val) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Error",
          text: this.$t('settings.holiday.messages.select_one_currency'),
          icon: "AlertTriangleIcon",
          variant: "warning",
        },
      });
    },
    holidayNotFoundMessage(val) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Error",
          text: this.$t('settings.holiday.messages.holiday_not_found'),
          icon: "AlertTriangleIcon",
          variant: "warning",
        },
      });
    },
    wrongToastMessage(val) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Error",
          text: val,
          icon: "AlertTriangleIcon",
          variant: "warning",
        },
      });
    },
    createHolidayToastMessage(val) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Successfully",
          text: this.$t('settings.holiday.messages.holiday_crate_success'),
          icon: "ThumbsUpIcon",
          variant: "success",
        },
      });
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    clearDate() {
        this.newHoliday.date = null
    },
    dateFormat(val) {
      if (val != undefined) {
        return moment(String(val)).format("MM-DD-YYYY");
      }
    },
    dateFormatWithTime(val) {
      if (val != undefined) {
        return moment(String(val)).format("MM-DD-YYYY HH:mm:ss");
      }
    },
  },
  watch: {
    perPage: {
      handler: function(val, before) {
        localStorage.setItem("userShow", val);
      },
    },
    rangeDate: {
      handler: function(val, before) {
        if (val != null) {
          if (val.includes("to")) {
            this.filterDateStart = this.rangeDate.split(" to ")[0];
            this.filterDateEnd = this.rangeDate.split(" to ")[1];

            this.selectedEvents();
          }
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
